<style scoped>
::v-deep .form-group{
  margin-bottom : 3px !important
}
</style>

<template>
  <div>
    <b-form-group 
      v-if="isSelectDisplayed(optionsLTDN)"
      :label="titleLTDN" 
      label-class="label-style">
      <b-spinner v-if="loading" variant="primary" label="Chargement en cours..." />
      <template v-else>
        <multiselect 
          :value="selectedValueLTDN" 
          label="label" 
          track-by="id"
          :options="optionsLTDN" 
          :multiple="multiple" :show-labels="false"
          :hide-selected="false" 
          :close-on-select="!multiple" 
          :allow-empty="true" placeholder=""
          :group-values="groupValues" 
          :group-label="groupLabel" 
          :group-select="multiple"
          @input="updateSelectedValues($event, siteTopGroupEnum.LTDN)" 
        />
        <b-form-checkbox 
          v-if="selectAll" 
          v-model="selectAllOptionsLTDN" 
          name="select-all" 
          switch
          @change="toggleSelectAll(siteTopGroupEnum.LTDN)">
          {{ $t("filter.select_all") }}
        </b-form-checkbox>
      </template>
    </b-form-group>
    <b-form-group 
      v-if="isSelectDisplayed(optionsFranchise)"
      :label="franchiseLabel" 
      label-class="label-style">
      <b-spinner v-if="loading" variant="primary" label="Chargement en cours..." />
      <template v-else>
        <multiselect 
          :value="selectedValueFranchise" 
          label="label" 
          track-by="id" 
          :options="optionsFranchise"
          :multiple="multiple" 
          :show-labels="false" 
          :hide-selected="false" 
          :close-on-select="!multiple"
          :allow-empty="true" placeholder="" 
          :group-values="groupValues" 
          :group-label="groupLabel"
          :group-select="multiple" 
          @input="updateSelectedValues($event, siteTopGroupEnum.FRANCHISE)" 
        />
        <b-form-checkbox v-if="selectAll" v-model="selectAllOptionsFranchise" name="select-all" switch
          @change="toggleSelectAll(siteTopGroupEnum.FRANCHISE)">
          {{ $t("filter.select_all") }}
        </b-form-checkbox>
      </template>
    </b-form-group>
    <b-form-group
      v-if="isSelectDisplayed(optionsNotFranchise)" 
      :label="titleNotFranchise" 
      label-class="label-style">
      <b-spinner v-if="loading" variant="primary" label="Chargement en cours..." />
      <template v-else>
        <multiselect 
          :value="selectedValueNotFranchise" 
          label="label" 
          track-by="id" 
          :options="optionsNotFranchise"
          :multiple="multiple" 
          :show-labels="false" 
          :hide-selected="false" 
          :close-on-select="!multiple"
          :allow-empty="true" 
          placeholder="" 
          :group-values="groupValues" 
          :group-label="groupLabel"
          :group-select="multiple" 
          @input="updateSelectedValues($event, siteTopGroupEnum.NOT_FRANCHISE)" />
        <b-form-checkbox v-if="selectAll" v-model="selectAllOptionsNotFranchise" name="select-all" switch
          @change="toggleSelectAll(siteTopGroupEnum.NOT_FRANCHISE)">
          {{ $t("filter.select_all") }}
        </b-form-checkbox>
      </template>
    </b-form-group>
  </div>
</template>

<script>
import Tools from "@/utils/tools";
import TableTools from "@/utils/tableTools";
import _ from "lodash";
import { siteTopGroupEnum } from "@/model/businessEnum";
import dimensionEnum from "@/model/dimensionEnum";
import store from "@/store";

export default {
  name: "FilterSitePicker",
  props: {
    groupByKey: {
      type: String,
      default: "",
    },
    groupByLabel: {
      type: String,
      default: "",
    },
    itemKey: {
      type: String,
      default: "",
    },
    itemLabel: {
      type: String,
      default: "",
    },
    itemCurrency: {
      type: String,
      default: "EUR",
    },
    useDefaultValue: {
      type: Boolean,
      default() {
        return false;
      },
    },
    multiple: {
      type: Boolean,
      default() {
        return false;
      },
    },
    selectAll: {
      type: Boolean,
      default() {
        return false;
      },
    },
    operator: {
      type: String,
      default() {
        return "equals";
      },
      validator: function (value) {
        // The value must match one of these strings
        return [
          "equals",
          "notEquals",
          "contains",
          "notContains",
          "gt",
          "gte",
          "lt",
          "lte",
          "set",
          "notSet",
          "inDateRange",
          "notInDateRange",
          "beforeDate",
          "afterDate",
          "contains",
          "notContains",
          "gt",
          "gte",
        ].includes(value);
      },
    },
  },
  data: function () {
    return {
      titleLTDN: this.$t('Site.siteLTDN'),
      titleFranchise: this.$t('Site.siteFranchise'),
      titleFranchiseKeyplay: this.$t('Site.siteFranchiseKeyplay'),
      titleNotFranchise: this.$t('Site.siteNotFranchise'),
      optionsFranchise: [],
      optionsNotFranchise: [],
      optionsLTDN: [],
      selectedValueFranchise: null,
      selectedValueNotFranchise: null,
      selectedValueLTDN: null,
      selectedFilter: null,
      loading: true,
      groupId: "groupId",
      groupLabel: "groupLabel",
      groupValues: "groupValues",
      groupFranchise: "groupFranchise",
      groupFranchiseValues: "groupFranchiseValues",
      selectAllOptionsFranchise: false,
      selectAllOptionsNotFranchise: false,
      selectAllOptionsLTDN: false,
      selectAllOptions: false,
      siteTopGroupEnum: siteTopGroupEnum,
      groupByFranchise: dimensionEnum.SITE_FRANCHISE,
      ltdnCategoryId: window.LTDN_CATEGORY_ID,
    };
  },
  computed: {
    selectedValue() {
      const franchise = this.selectedValueFranchise || [];
      const notFranchise = this.selectedValueNotFranchise || [];
      const ltdn = this.selectedValueLTDN || [];
      return [...franchise, ...notFranchise, ...ltdn];
    },
    optionsFlattened() {
      var optionsFranchise = this.optionsFranchise.map((o) => o[this.groupValues]).flat();
      var optionsNotFranchise = this.optionsNotFranchise.map((o) => o[this.groupValues]).flat();
      var optionsLTDN = this.optionsLTDN.map((o) => o[this.groupValues]).flat();
      return [...optionsFranchise, ...optionsNotFranchise, ...optionsLTDN];
    },
    optionsFlattenedFranchise() {
      return this.optionsFranchise.map((o) => o[this.groupValues]).flat();
    },
    optionsFlattenedNotFranchise() {
      return this.optionsNotFranchise.map((o) => o[this.groupValues]).flat();
    },
    optionsFlattenedLTDN() {
      return this.optionsLTDN.map((o) => o[this.groupValues]).flat();
    },
    allOptions() {
      return [...this.optionsLTDN, ...this.optionsFranchise, ...this.optionsNotFranchise]
    },
    franchiseLabel() {
      return this.isSelectDisplayed(this.optionsFranchise) && 
      (!this.isSelectDisplayed(this.optionsNotFranchise) && !this.isSelectDisplayed(this.optionsLTDN)) ?
        this.titleFranchiseKeyplay :
        this.titleFranchise;
    }
  },
  mounted: async function () {
    this.$on("sites-updated", this.handleSitesUpdated);
    await this.loadData();
  },

  methods: {
    updateSelectedValues(selectedValues, from) {
      if (from && this.multiple) {
        switch (from) {
          case siteTopGroupEnum.FRANCHISE:
            selectedValues.push(...(this.selectedValueNotFranchise || []));
            selectedValues.push(...(this.selectedValueLTDN || []));
            break;
          case siteTopGroupEnum.NOT_FRANCHISE:
            selectedValues.push(...(this.selectedValueFranchise || []));
            selectedValues.push(...(this.selectedValueLTDN || []));
            break;
          case siteTopGroupEnum.LTDN:
            selectedValues.push(...(this.selectedValueFranchise || []));
            selectedValues.push(...(this.selectedValueNotFranchise || []));
            break;
        }
      }
      
      if (selectedValues) {
        if (!Array.isArray(selectedValues)) {
          selectedValues = [selectedValues];
        } else if (selectedValues.length < 1) {
          const defaultValue = this.defaultOption(this.allOptions);
          this.distributeSelectedValues(defaultValue);
          selectedValues = defaultValue;
        }
      } else {
        const defaultValue = this.defaultOption(this.allOptions);
        this.distributeSelectedValues(defaultValue);
        selectedValues = defaultValue;
      }
      
      // attribution des selectedValue pour chaque select
      this.distributeSelectedValues(selectedValues);
      
      const idValues = selectedValues.map((v) => v.id);

      this.selectAllOptionsFranchise =
        (this.selectedValueFranchise || []).length === this.optionsFlattenedFranchise.length;

      this.selectAllOptionsNotFranchise =
        (this.selectedValueNotFranchise || []).length === this.optionsFlattenedNotFranchise.length;

      this.selectAllOptionsLTDN =
        (this.selectedValueLTDN || []).length === this.optionsFlattenedLTDN.length;

      this.selectAllOptions =
        this.selectedValue.length === this.optionsFlattened.length;

      if (selectedValues) {
        this.selectedFilter = {
          dimension: this.itemKey,
          operator: this.operator,
          values: idValues,
        };
      } else {
        this.selectedFilter = null;
      }
      
      Tools.StorageHelper.storeFilterSelectedValue(this.itemKey, idValues);
      this.$emit("filterWithIdChanged", {
        idFilter: this.selectedFilter,
        values: selectedValues,
      });
    },

    distributeSelectedValues(selectedValues) {
      let tempSelectedValueFranchise = [], tempSelectedValueNotFranchise = [], tempSelectedValueLTDN = [];

      selectedValues.forEach(site => {
        const isInFranchise = this.optionsFranchise.some(siteInFranchise =>
          siteInFranchise.groupValues.some(value => value.id === site.id)
        );
        const isInLTDN = this.optionsLTDN.some(siteInLTDN =>
          siteInLTDN.groupValues.some(value => value.id === site.id)
        );

        if (isInLTDN) {
          tempSelectedValueLTDN.push(site);
        } else if (isInFranchise) {
          tempSelectedValueFranchise.push(site);
        } else {
          tempSelectedValueNotFranchise.push(site);
        }
      });

      this.selectedValueFranchise = tempSelectedValueFranchise;
      this.selectedValueNotFranchise = tempSelectedValueNotFranchise;
      this.selectedValueLTDN = tempSelectedValueLTDN;
    },

    async loadData() {
      await this.loadOptions().catch(() => {
        if (!window.navigator.onLine) {
          Tools.Alerts.Error(
            this.$swal,
            this.$t("alerts.alertFilterPickerMessageNoConnexion"),
            this.$t("alerts.alertFilterPickerTitleNoConnexion")
          );
        } else {
          Tools.Alerts.Error(
            this.$swal,
            this.$t("alerts.alertFilterPickerMessage"),
            this.$t("alerts.alertFilterPickerTitle")
          );
        }
      });
      this.setDefaultSelectedValue(this.useDefaultValue);
      this.loading = false;
    },

    async handleSitesUpdated() {
      this.loading = true;
      await this.loadData();
    },

    loadOptions: async function () {
      var dataQuery = {
        dimensions: [
          this.groupByFranchise,
          this.groupByKey,
          this.groupByLabel,
          this.itemKey,
          this.itemLabel,
          this.itemCurrency
        ],
      };
      const resultSet = await TableTools.Helper.doRequest(dataQuery);
      var groupedOptions = _.chain(resultSet)
        .groupBy(this.groupByFranchise)
        .map((franchise) => {
          return {
            [this.groupFranchise]: franchise[0][this.groupByFranchise],
            [this.groupFranchiseValues]: _.chain(franchise)
              .groupBy(this.groupByKey)
              .map((value) => {
                return {
                  [this.groupId]: value[0][this.groupByKey],
                  [this.groupLabel]: value[0][this.groupByLabel],
                  [this.groupValues]: value
                    .map((o) => {
                      return {
                        id: o[this.itemKey],
                        label: o[this.itemLabel],
                        currency: o[this.itemCurrency],
                      };
                    })
                    .sort((a, b) =>
                      a.label.localeCompare(b.label, undefined, {
                        sensitivity: "base",
                      })
                    ),
                };
              })
              .value()
          }
        })
        .value();

      this.optionsFranchise = (_.find(groupedOptions, { groupFranchise: true })?.[this.groupFranchiseValues]) ?? [];
      this.optionsNotFranchise = (_.find(groupedOptions, { groupFranchise: false })?.[this.groupFranchiseValues]) ?? [];
      // séparation de la catégorie LTDN pour un troisième select
      this.optionsLTDN = (() => {
        const found = _.find(this.optionsFranchise, { groupId: this.ltdnCategoryId });
        _.remove(this.optionsFranchise, { groupId: this.ltdnCategoryId });
        return found ? [found] : [];
      })();
    },
    removeFromSelectedValue(arrayToRemove) {
      const currentSelected = this.selectedValue;
      const filteredSelected = currentSelected.filter(site =>
        !arrayToRemove.some(siteToRemove => site.id === siteToRemove.id)
      );
      this.distributeSelectedValues(filteredSelected);
    },
    toggleSelectAll(from) {
      if (from === siteTopGroupEnum.LTDN) {
        this.removeFromSelectedValue(this.selectedValueLTDN || []);
        if (this.selectAllOptionsLTDN) {
          if (this.allOptions && this.allOptions.length) {
            const newSelected = [...this.selectedValue, ...this.optionsFlattenedLTDN];
            this.distributeSelectedValues(newSelected);
          } else {
            this.selectedValueLTDN = [];
          }
        } else {
          this.selectedValueLTDN = [];
        }
      } else if (from === siteTopGroupEnum.FRANCHISE) {
        this.removeFromSelectedValue(this.selectedValueFranchise || []);
        if (this.selectAllOptionsFranchise) {
          if (this.allOptions && this.allOptions.length) {
            const newSelected = [...this.selectedValue, ...this.optionsFlattenedFranchise];
            this.distributeSelectedValues(newSelected);
          } else {
            this.selectedValueFranchise = [];
          }
        } else {
          this.selectedValueFranchise = [];
        }
      } else {
        this.removeFromSelectedValue(this.selectedValueNotFranchise || []);
        if (this.selectAllOptionsNotFranchise) {
          if (this.allOptions && this.allOptions.length) {
            const newSelected = [...this.selectedValue, ...this.optionsFlattenedNotFranchise];
            this.distributeSelectedValues(newSelected);
          } else {
            this.selectedValueNotFranchise = [];
          }
        } else {
          this.selectedValueNotFranchise = [];
        }
      }

      this.updateSelectedValues(this.selectedValue);
    },

    defaultOption: function (options) {
      return [options[0][this.groupValues][0]];
    },

    setDefaultSelectedValue: function (useDefaultValue) {
      if (this.allOptions === null || this.allOptions.length === 0) {
        this.selectedValueFranchise = null;
        this.selectedValueNotFranchise = null;
        this.selectedValueLTDN = null;
      } else if (this.optionsFlattened && this.optionsFlattened.length) {
        const storedSelectedIdValues = Tools.StorageHelper.getStoredFilterSelectedValue(
          this.itemKey
        );
        if (storedSelectedIdValues && storedSelectedIdValues.length) {
          const selectableValues = this.optionsFlattened.filter((o) =>
            storedSelectedIdValues.some((id) => o.id === id)
          );
          const selectedValue = this.multiple ? selectableValues : selectableValues[0];
          this.updateSelectedValues(Array.isArray(selectedValue) ? selectedValue : [selectedValue]);
        }
        if (useDefaultValue && (!this.selectedValue || !this.selectedValue.length)) {
          const defaultValue = this.defaultOption(this.allOptions);
          this.updateSelectedValues(defaultValue);
        }
      }
    },
    isAdmin: function () {
      const userRoleRank = store.getters["authentication/getRoleRank"];
      // 1 = AdminMBA
      // 2 = Admin
      return userRoleRank <= 2;
    },
    isSelectDisplayed: function (options) {
      return this.isAdmin() || options.length > 0;
    }
  },
};
</script>

<style>
.label-style{
  flex: 1;
  text-align: left;
  font-weight: bold;
}
</style>